import React from "react";
import { useDispatch } from "react-redux";
import { useCreateColAsset, useMeasuresAndDimensions } from "./insAssetsDataExportGrid.setup";
import { prepareTagRows } from "components/tags/helpers";
import { useFetchTagsQuery } from "components/tags/tagsApi";
import { TagEntityType } from "components/tags/types";
import { InsGrid } from "components/widgets";
import { insDatapointGridWidgetAdapterData } from "components/widgets/grid/insDatapointGridWidgetAdapter";
import { useCustomDataDatapointsRequest, useGetCustomDataDatapoints } from "hooks/use-custom-data-datapoints";
import { setSelectedRowsState } from "store/grids";
export const InsAssetsDataExportGrid = (props) => {
    const dispatch = useDispatch();
    const { dimensions, measures } = useMeasuresAndDimensions([]);
    const request = useCustomDataDatapointsRequest(dimensions, measures, props.stateId, "USD"), [data, querystate] = useGetCustomDataDatapoints(request);
    const cols = useCreateColAsset();
    const { rows, totals } = insDatapointGridWidgetAdapterData(data, cols);
    const { data: tags } = useFetchTagsQuery({ entityType: TagEntityType.ASSET });
    const newRows = prepareTagRows(rows, tags);
    return React.createElement(React.Fragment, null,
        React.createElement(InsGrid, { stateId: props.stateId, widgetId: props.stateId, selectionMode: "multiple", rowSelectedHandler: ((e) => {
                dispatch(setSelectedRowsState({
                    id: props.stateId,
                    selectedRows: e.api.getSelectedRows()
                        .map((row) => `${row.Id}`)
                }));
            }), columnDefs: cols, rowData: newRows, totalData: totals, queryState: querystate }));
};
